// @flow

import React from 'react'
import type { Node } from 'react'
import classnames from 'classnames'
import { compose } from 'recompose'
import { withI18n } from '@lingui/react'
import withStyles from 'material-ui/styles/withStyles'

type Props = {
  anchor: string,
  classes: Object,
  className: string,
  children: Node,
  i18n: Object,
}

const Section = ({
  anchor,
  classes,
  className,
  children,
  i18n,
}: Props) => (
  <section
    className={classnames(classes.root, className)}
    id={i18n._(anchor)}
  >
    {children}
  </section>
)

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    position: 'relative',
    padding: `${theme.spacing.unit * 10}px ${theme.spacing.unit * 2}px`,
    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing.unit * 10}px ${theme.spacing.unit * 3}px`,
    },
  },
})

export default compose(
  withStyles(styles),
  withI18n(),
)(Section)



// WEBPACK FOOTER //
// ./src/components/Section/index.js